import type { MessageBlock } from "@rakazo/contracts";

/** Undo empties the checklist as well as marking it, so older clients hide it too. */
export function isRetiredImportSetup(block: MessageBlock): boolean {
  return block.kind === "import_setup" && (block.undone === true || block.items.length === 0);
}

export function isToolActivityBlock(block: MessageBlock): boolean {
  return (
    (block.kind === "steps" && !block.plan) ||
    (block.kind === "progress" && block.activity === true)
  );
}
